
class exports.CancelDialog extends DialogHandler

    constructor: () ->
        super()

        @layoutSource   = null
        @layoutUrl      = null

        @modalOptions   =
            backdrop: true

        @classes = 'small_dialog'
        @savingBtnMsg = 'Cancelling...'
        @savedBtnMsg = 'Cancelled'

        # Kidnap some leaflet stuff, because it's nice!
        L.extend(this, L.Mixin.Events)

        @destroyOnYes   = true
        @destroyOnNo    = true

        @content = {
            yes: ' Cancel',
            no: ' Go Back',
            body: 'Are you sure you want to Cancel?'
            title: 'Cancel'
        }

    setContent: ( content = {} ) ->
        @content = $.extend @content, content

    afterLoadLayout: (selector, response) ->
        @dialog.html($('.cancel-dialog-template').render(@content))
        @openDialog()


        @fire('cancel:loaded')

        @dialog.find('.cancel-yes, .save-btn').on 'click', (e) =>
            @response = true
            @fire 'cancel:yes', e

            @destroy() if @destroyOnYes


        @dialog.find('.cancel-no, [data-dismiss="modal"]').on 'click', (e) =>
            @fire 'cancel:no', e
            #dismiss already calls destroy

    destroy: () ->
        return if @isDestroyed()
        @fire('cancel:destroyed')

        @clearAllEventListeners()
        super()
